import React, { useEffect, useState } from 'react';
import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import axios from 'axios';
import './scss/AuthUser.scss';
import { Toast, ToastContainer } from 'react-bootstrap';

const AuthUser = ({ onAuthSuccess }) => {
  const [emailForm, setEmailForm] = useState("");
  const [isError, setIsError] = useState(false);
  const auth = () => {
    if (emailForm == "esstech@mail.ru") {
      const fakeToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9." +
                      "eyJ1c2VySWQiOiIxMjMiLCJleHAiOjQ3NTc5MjAwMDB9." +
                      "signature";
  
      localStorage.setItem("jwtToken", fakeToken);
      onAuthSuccess(); // сообщает App, что авторизация прошла
    }
    else {
      setIsError(true);
    }
  };
  
  return (
    <>
      
      <div className="logo-esstech-auth">
        <h1>ESSTECH</h1>
      </div>
      <div className="login">
        <div className="auth-container">
          <div className="header-auth">Вход в аккаунт</div>
            {isError && (
              <div className='error'>
                Неверный пользователь
              </div>
            )}
          <div className="form-floating mb-3">
            <input type="email" value={emailForm} onChange={(e) => {setEmailForm(e.target.value)}} placeholder="" id="floatingInputName" className="form-control" />
            <label for="floatingInputName">Введите ваш E-mail</label>
          </div>
          <div className="btn btn-save" onClick={auth}>Войти</div>
        </div>
      </div>
    </>
  );
}

export default AuthUser;
